<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
    import {secretCookie} from '@/tools/tool'
    export default {
        name: 'App',
        mounted () {
            secretCookie()
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue